module.exports = __webpack_public_path__ + "4ed96ef83bdf8e7852b171e27bb65c34.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/select-shapes/images/Trilliant@2x.png
// module id = 334
// module chunks = 0